import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { usePsfSharePageData } from '#src/app/pages/psf/share/pageContext';
import { useQueryParamValue } from '#src/app/shared/hooks/location';

import { getComboChipInAmount } from './getComboChipInAmount';

/**
 * The chip-in amount the Combo page showed, when it carried it here in the same currency this page
 * uses, so the slide-up asks for the same amount; otherwise the page's own fallback amount.
 */
export function useChipInAmount() {
	const {
		data: { chipInAmount, chipInAmountLocalized, chipInCurrencyCode, chipInExchangeRate },
	} = usePsfSharePageData();
	const comboStaticAmount = useQueryParamValue('psf_combo_static_amount');
	const comboStaticCurrency = useQueryParamValue('psf_combo_static_currency');
	const { localizeCurrency } = useI18n();

	return useMemo(() => {
		const comboAmount = getComboChipInAmount(comboStaticAmount, comboStaticCurrency, chipInCurrencyCode);
		if (comboAmount === undefined) {
			return { chipInAmount, chipInAmountLocalized, chipInCurrencyCode, chipInExchangeRate };
		}
		return {
			chipInAmount: comboAmount,
			chipInAmountLocalized: localizeCurrency(comboAmount, chipInCurrencyCode),
			chipInCurrencyCode,
			chipInExchangeRate,
		};
	}, [
		comboStaticAmount,
		comboStaticCurrency,
		chipInAmount,
		chipInAmountLocalized,
		chipInCurrencyCode,
		chipInExchangeRate,
		localizeCurrency,
	]);
}
